export default "https://cdn-gra-staging.amplement.io/statics/images/pattern-file-link@2x.png";